export default __webpack_public_path__ + "static/media/PHK基金会_white.ec509edd.jpg";